import styled from 'styled-components';
import { textLinkPrimary } from 'styles-js/mixins/typography';

export const LinkButton = styled.button`
  border: 0;
  padding: 0;
  -webkit-appearance: none;
  background-color: transparent;
  ${textLinkPrimary};
`;
